import { colorToAlpha } from "@bridgesplit/utils";
import { PaletteOptions } from "@mui/material";

import { BRAND_COLORS } from "./theme";

export function getDarkPalette(): PaletteOptions {
    return {
        primary: {
            main: BRAND_COLORS.LIGHT
        },
        secondary: {
            main: BRAND_COLORS.BLUE
        },
        background: {
            default: BRAND_COLORS.BLACK,
            paper: BRAND_COLORS.BLACK
        },
        success: {
            main: "#0FB872"
        },
        error: {
            main: "#DF5C5F"
        },
        warning: {
            main: BRAND_COLORS.ORANGE
        },
        info: {
            main: "#4A88FF"
        },
        divider: colorToAlpha(BRAND_COLORS.LIGHT, 0.08),
        text: {
            primary: BRAND_COLORS.LIGHT,
            secondary: BRAND_COLORS.GRAY,
            disabled: colorToAlpha(BRAND_COLORS.LIGHT, 0.4)
        }
    };
}
